import React from 'react';
import Navbar from '../components/Navbar';
import LegalSection from '../components/LegalSection';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import logo from '../img/logo.png';

const Legal = () => {
  return (
    <>
      <nav className="stroke navbar navbar-expand-md navbar-light bg-light fixed-top shadow-sm">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="Kanzlei Logo" className="navbar-logo" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
  <ul className="navbar-nav ms-auto">
    <li className="nav-item">
      <Link className="nav-link" to="/">Home</Link>
    </li>
    <li className="nav-item">
      <Link className="nav-link" to="/#taetigkeiten">Tätigkeiten</Link>
    </li>
    <li className="nav-item">
      <Link className="nav-link" to="/#ueber-mich">Über mich</Link>
    </li>
    <li className="nav-item">
      <Link className="nav-link" to="/#arbeitsweise">Arbeitsweise & Vorteile</Link>
    </li>
    <li className="nav-item">
      <Link className="nav-link" to="/#kontakt">Kontakt</Link>
    </li>
  </ul>
</div>
      </div>
    </nav>
      <LegalSection title="Impressum">
        <p><strong>Angaben gemäß § 5 Telemediengesetz (TMG)</strong></p>
        <p>
          Rechtsanwalt Sergej Vorrat<br />
          Kobergerplatz 13<br />
          90408 Nürnberg
        </p>

        <h2>Kontakt</h2>
        <p>
          Telefon: 01577 3430153<br />
          E-Mail: kanzlei@ravorrat.de<br />
          Webseite: <a href="https://ra-vorrat.de" target="_blank" rel="noopener noreferrer">https://ra-vorrat.de</a>
        </p>

        <h2>Zuständige Kammer / Aufsichtsbehörde</h2>
        <p>
          Rechtsanwaltskammer für den Oberlandesgerichtsbezirk Nürnberg<br />
          Fürther Straße 115<br />
          90429 Nürnberg<br />
          Webseite: <a href="https://www.rak-nbg.de" target="_blank" rel="noopener noreferrer">https://www.rak-nbg.de</a>
        </p>
        <p>Rechtsanwalt Sergej Vorrat ist Mitglied der Rechtsanwaltskammer Nürnberg.</p>

        <h2>Gesetzliche Berufsbezeichnung / Berufsrechtliche Regelungen</h2>
        <p>
          Gesetzliche Berufsbezeichnung: Rechtsanwalt<br />
          Staat der Verleihung: Bundesrepublik Deutschland
        </p>
        <p>Es gelten die folgenden berufsrechtlichen Regelungen:</p>
        <ul>
          <li>Bundesrechtsanwaltsordnung (BRAO)</li>
          <li>Berufsordnung für Rechtsanwälte (BORA)</li>
          <li>Rechtsanwaltsvergütungsgesetz (RVG)</li>
          <li>Berufsregeln der Rechtsanwälte der Europäischen Union (CCBE)</li>
        </ul>
        <p>
          Diese Regelungen können eingesehen werden unter: <a href="https://www.brak.de/fuer-anwaelte/berufsrecht/" target="_blank" rel="noopener noreferrer">https://www.brak.de/fuer-anwaelte/berufsrecht/</a>
        </p>

        <h2>Berufshaftpflichtversicherung (§ 51 BRAO)</h2>
        <p>
          Versicherer: Markel Insurance SE<br />
          Anschrift: Sophienstraße 26, 80333 München<br />
          Räumlicher Geltungsbereich: Europäische Union<br />
          Die Berufshaftpflichtversicherung erfüllt die Anforderungen des § 51 BRAO.
        </p>

        <h2>Verantwortlicher nach § 18 Abs. 2 MStV</h2>
        <p>
          Sergej Vorrat<br />
          Kobergerplatz 13<br />
          90408 Nürnberg
        </p>

        <h2>Außergerichtliche Streitbeilegung</h2>
        <p>
          Plattform der EU-Kommission zur Online-Streitbeilegung (OS-Plattform): <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a>
        </p>
        <p>
          Für vermögensrechtliche Streitigkeiten aus dem Mandatsverhältnis ist die Schlichtungsstelle der Rechtsanwaltschaft, Rauchstraße 26, 10787 Berlin, <a href="https://www.s-d-r.org" target="_blank" rel="noopener noreferrer">https://www.s-d-r.org</a> zuständig.
        </p>
        <p>
          Ich bin grundsätzlich nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor dieser Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h2>Urheberrecht</h2>
        <p>
          Die auf dieser Website veröffentlichten Inhalte und Werke unterliegen dem deutschen Urheberrecht.<br />
          Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der vorherigen schriftlichen Zustimmung des jeweiligen Rechteinhabers.<br />
          Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.<br />
          Soweit Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.<br />
          Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden derartige Inhalte umgehend entfernt.
        </p>
      </LegalSection>
      <Footer />
    </>
  );
};

export default Legal;
